import axiosInstance from "./axiosInstance";

const apiUrl = process.env.REACT_APP_API_URL;

export async function getNotificationApi(cmpid, custid) {
  const response = await axiosInstance.get(
    `${apiUrl}/api/get-notifications/?companytransid=${cmpid}&customertransid=${custid}`,
  );
  return response.data;
}

export async function UpdateNotificationStatusApi(formData) {
  const response = await axiosInstance.post(
    `${apiUrl}/api/update_notification_status/`,
    formData,
  );
  return response.data;
}

export async function clearAllNotificationsApi(formData) {
  const response = await axiosInstance({
    url: `${apiUrl}/api/notifications/hard-delete/`,
    method: "delete",
    data: formData, // delete body
  });
  
  return response.data;
}
